import InputMask from "./InputMask";
import Inputmask from 'inputmask-core';
import CountryPhonesSelect from "../CountryPhonesSelect";

export default class CountryPhoneMask extends InputMask
{
    protected input: HTMLInputElement;
    private select: CountryPhonesSelect;

    constructor(countryPhoneNode: string|HTMLElement, defaultCountry: string = 'RUS')
    {
        if (typeof countryPhoneNode === 'string') {
            countryPhoneNode = document.querySelector(countryPhoneNode) as HTMLElement;
        }

        let input = countryPhoneNode.querySelector('input[name="country_phone"]') as HTMLInputElement;
        let selectNodes = countryPhoneNode.querySelectorAll('.styled-select') as NodeListOf<HTMLElement>;
        let selectNode  = selectNodes.item(0);
        let defaultValue = selectNode.querySelector('.styled-select__checkbox[value="'+ defaultCountry +'"]');
        let pattern = defaultValue?.getAttribute('data-mask') || '';

        if (pattern === '') {
            throw new Error("Не удалось загрузить маску ввода");
        }

        super(input, pattern);
            
        this.input = input;
        this.select = new CountryPhonesSelect(selectNodes);
        this.select.set(selectNode, defaultCountry);
        this.select.init();

        this.setPattern(pattern);

        this.appendValueSelectedHandler(selectNode);
    }

    protected initInputMask(pattern: string)
    {
        return new Inputmask({
            pattern: pattern,
            placeholderChar: '_',
            formatCharacters: {
                '1': null,
                '#': {
                    validate: char => /\d/.test(char)
                },
                'K': { // for Kazakhstan
                    validate: char => /6|7/.test(char)
                }
            }
        });
    }

    protected appendValueSelectedHandler(box: HTMLElement)
    {
        box.addEventListener('valueselected', e => {
            let pattern = this.select.getSelectedDataAttribute(box, 'mask').pop() || '';

            if (pattern !== '') {
                this.setPattern(pattern);
            } else {
                throw new Error("Не удалось получить маску ввода");
            }
    
            this.input.focus();
        });
    }

    private setPattern(pattern: string)
    {
        let firstNumber = pattern.search(/#|K/);

        this.mask.setPattern(pattern, {
            selection: {
                start: firstNumber,
                end: firstNumber,
            }
        });
    }
}
